import { render, staticRenderFns } from "./Order_customer_detail.vue?vue&type=template&id=92f70140&scoped=true&"
import script from "./Order_customer_detail.vue?vue&type=script&lang=js&"
export * from "./Order_customer_detail.vue?vue&type=script&lang=js&"
import style0 from "./Order_customer_detail.vue?vue&type=style&index=0&id=92f70140&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f70140",
  null
  
)

export default component.exports